export default "__VITE_ASSET__D8EJxOL4__"